import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { DotCMSEnvVars } from '@nx-averycom/shared/avry-models';
import { createCookie, getCookie } from '@nx-averycom/shared/utils';
import axios, { AxiosResponse } from 'axios';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Duplicate DY cookie as a workaround for Safari's Internet Tracking Prevention (ITP) Policy
// https://support.dynamicyield.com/hc/en-us/articles/360007211797-Safari-s-Internet-Tracking-Prevention-ITP-Policy-
const _dyIdCookie = getCookie('_dyid');
if (_dyIdCookie && !getCookie('_dyid_server')) {
  createCookie('_dyid_server', _dyIdCookie, 365, '.avery.com');
}
const head = document.head;

const generateNavScript = (prodNavDeployId?: string) => {
  const navMainScript: HTMLScriptElement = document.createElement('script');
  const navRunTimeScript: HTMLScriptElement = document.createElement('script');
  const navPolyfillsScript: HTMLScriptElement =
    document.createElement('script');
  const navStyleLink: HTMLLinkElement = document.createElement('link');

  navMainScript.type = 'text/javascript';
  navRunTimeScript.type = 'text/javascript';
  navPolyfillsScript.type = 'text/javascript';
  navStyleLink.type = 'text/css';
  navStyleLink.rel = 'stylesheet';

  navRunTimeScript.src = prodNavDeployId
    ? `${environment.domain}/nav/runtime.${[prodNavDeployId]}.js`
    : `${environment.domain}/nav/runtime.js`;
  navMainScript.src = prodNavDeployId
    ? `${environment.domain}/nav/main.${[prodNavDeployId]}.js`
    : `${environment.domain}/nav/main.js`;
  navPolyfillsScript.src = prodNavDeployId
    ? `${environment.domain}/nav/polyfills.${[prodNavDeployId]}.js`
    : `${environment.domain}/nav/polyfills.js`;
  navStyleLink.href = prodNavDeployId
    ? `${environment.domain}/nav/styles.${[prodNavDeployId]}.css`
    : `${environment.domain}/nav/styles.css`;

  head.appendChild(navMainScript);
  head.appendChild(navRunTimeScript);
  head.appendChild(navPolyfillsScript);
  head.appendChild(navStyleLink);
};
// Lazysizes Script
const lazysizesScript: HTMLScriptElement = document.createElement('script');
lazysizesScript.type = 'text/javascript';
lazysizesScript.src = `${environment.domain}/app/js/lazysizes.min.js`;
lazysizesScript.defer = true;
head.appendChild(lazysizesScript);
if (environment.production) {
  enableProdMode();
}
// web components scripts
const megaMenuScript: HTMLScriptElement = document.getElementById(
  'new-nav-script'
) as HTMLScriptElement;
megaMenuScript.src = `${environment.navDomain}/mega-menu.js`;

const mobileNavScript: HTMLScriptElement = document.getElementById(
  'new-mobile-nav-script'
) as HTMLScriptElement;
mobileNavScript.src = `${environment.navDomain}/mobile-nav.js`;

const megaMenuStyle: HTMLLinkElement = document.getElementById(
  'new-nav-style'
) as HTMLLinkElement;
megaMenuStyle.href = `${environment.navDomain}/index.main.css`;

const avyFooter: HTMLScriptElement = document.getElementById(
  'avy-footer'
) as HTMLScriptElement;
avyFooter.src = `${environment.navDomain}/footer.js`;

const typeahead: HTMLScriptElement = document.getElementById(
  'typeahead'
) as HTMLScriptElement;
typeahead.src = `${environment.navDomain}/search.js`;

const liveChat: HTMLScriptElement = document.getElementById(
  'live-chat'
) as HTMLScriptElement;
liveChat.src = `${environment.navDomain}/live-chat-widget.js`;

// nav scripts
if (
  environment.environment === 'prod' ||
  environment.environment === 'live' ||
  environment.environment === 'bkp'
) {
  const siteDomain = environment.domain;
  // Using hashed nav script
  axios
    .get(`${siteDomain}/api/vtl/site_vars.json`)
    .then((res: AxiosResponse<DotCMSEnvVars[]>) => {
      const { bkpnavdeployid, prodnavdeployid } = res.data[0];

      if (prodnavdeployid) {
        generateNavScript(prodnavdeployid);
      } else if (bkpnavdeployid) {
        generateNavScript(bkpnavdeployid);
      }
    })
    .catch((err) => console.log(err));
} else {
  // no hased version
  generateNavScript();
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
